
import gql from 'graphql-tag';
import { client } from '../data/api/client/client';


export const Q_GET_CURRRENT_USER_ID = gql`
    {
        currentUserId @client
    }
`;

export const Q_GET_CURRRENT_USER = gql`
    {
        currentUser @client {
            id
            username
            email
            created_at
            updated_at
            org_id
            avatar
        }
    }
`;

export function getCurrentUserId() {
    try {
        console.log('function getCurrentUserId() just fired...')
        const response = client.readQuery({
            query: Q_GET_CURRRENT_USER_ID
        });
        console.log('function getCurrentUserId() client.readQuery(Q_GET_CURRRENT_USER_ID)', response);
        console.log('function getCurrentUserId() client.readQuery(Q_GET_CURRRENT_USER_ID)', response.currentUserId);
        return response.currentUserId;
    }
    catch (error) {
        console.log('ERROR: function getCurrentUserId() client.readQuery(Q_GET_CURRRENT_USER_ID)', error);
        return undefined;
    }
   
}

export function getCurrentUser() {
    try {
        console.log('function getCurrentUserId() just fired...')
        // get user object
        const currentUser = client.readQuery({
            query: Q_GET_CURRRENT_USER
        });

        console.log('function getCurrentUserId() client.readQuery(Q_GET_USER_INFO)', currentUser);
        return currentUser && currentUser.currentUser ? currentUser.currentUser : undefined;
    }
    catch (error) {
        // console.log(error);
        console.log('getCurrentUser failed: the user has not signed in');
        return undefined;
    }
}